<template>
  <div>
    <div class="save_info" v-if="isDataUpdating">Сохраняется</div>
    <div class="save_info" v-if="!isDataUpdating && elementVisible">Сохранено</div>
  </div>
</template>

<script>
export default {
  props: [
    'isDataUpdating'
  ],
  data() {
    return {
      elementVisible: false
    }
  },
  watch: {
    isDataUpdating() {
      if (!this.isDataUpdating) {
        this.elementVisible = true;
        setTimeout(() => this.elementVisible = false, 1000)
      }
    }
  },
  created() {

  }
}
</script>
<style>
  .save_info {
    display: inline-block;
    padding: 5px;
    font-size: 13px;
    background: #b9b9b9;
    color: #000;
    border: 1px solid #000;
    position: fixed;
    right: 20px;
    top: 180px;
    opacity: 0.7;
  }
	@media (max-width: 1000px) {
		.save_info {
				top: 20px;
		}
	}
</style>